// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JKaoSfG6VBIZ9GM5SGbC{height:44px;margin-top:40px;font-size:14px;font-weight:500}.XUNNXf6k9no0RpYGk1TL{margin:24px 0}.mLPEWUon2Bg2xW2UFIBv{padding:12px;font-size:14px;font-weight:400;line-height:20px}.mLPEWUon2Bg2xW2UFIBv.JK17EvV7Mc_yXyeB5c7w{margin-bottom:4px}.Bw68krvzwI0K7frqLwNg{margin-top:20px;margin-bottom:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `JKaoSfG6VBIZ9GM5SGbC`,
	"alertError": `XUNNXf6k9no0RpYGk1TL`,
	"textField": `mLPEWUon2Bg2xW2UFIBv`,
	"error": `JK17EvV7Mc_yXyeB5c7w`,
	"inputLabel": `Bw68krvzwI0K7frqLwNg`
};
export default ___CSS_LOADER_EXPORT___;
